<template>
  <div class="container py-5">
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h3 class="fw-bold text-primary">SEO Metadata Manager</h3>
          <div class="text-end mb-3">
            <select
              v-model="selectedLang"
              @change="onLangChange"
              class="form-select w-auto d-inline-block"
            >
              <option
                v-for="lang in languages"
                :key="lang.code"
                :value="lang.code"
              >
                {{ lang.language }}
              </option>
            </select>

            <select
          v-model="selectedCountry"
          @change="onCountryChange"
          class="form-select w-auto d-inline-block"
        >
          <option value="" disabled>Select Country</option>
          <option
            v-for="count in countries"
            :key="count.code"
            :value="count.code"
          >
            {{ count.country }}
          </option>
        </select>
          </div>
          <div>
            <button
              class="btn btn-outline-primary me-2 shadow-sm hover-white"
              data-bs-toggle="modal"
              data-bs-target="#createMetaModal"
            >
              New Metadata
            </button>
            <button
              class="btn btn-outline-info shadow-sm hover-white me-1"
              data-bs-toggle="modal"
              data-bs-target="#createTargetModal"
            >
              New Target
            </button>
            <button
              class="btn btn-outline-warning shadow-sm hover-white"
              data-bs-toggle="modal"
              data-bs-target="#viewTargetModal"
            >
              View Targets
            </button>
          </div>
        </div>
      </div>

      <!-- Metadata Table -->
      <div class="col-12 col-md-12">
        <div class="card shadow-sm">
          <div class="card-body p-0">
            <div class="table-responsive">
              <table class="table table-striped table-hover align-middle mb-0">
                <thead class="table-primary text-center">
                  <tr>
                    <th>#</th>
                    <th>Title</th>
                    <th>Type</th>
                    <th>Target Index</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(meta, i) in paginatedMetadata"
                    :key="meta.page_id"
                    class="text-center"
                  >
                    <td>{{ i + 1 + (currentPage - 1) * pageSize }}</td>
                    <td>{{ meta.title }}</td>
                    <td>{{ meta.type }}</td>
                    <td>{{ meta.target_index }}</td>
                    <td>
                      <!-- Meta Tags Button - solid blue -->
                      <button
                        class="btn btn-primary shadow-sm me-1"
                        data-bs-toggle="modal"
                        data-bs-target="#metaTagsModal"
                        @click="loadMetaTags(meta.page_id)"
                      >
                        Meta Tags
                      </button>

                      <!-- Schema Button - outline info -->
                      <button
                        class="btn btn-outline-info shadow-sm me-1"
                        @click="showSchema(meta.schema_json, meta.id)"
                      >
                        Schema
                      </button>

                      <button
                        class="btn btn-warning shadow-sm me-1"
                        @click="updateSchema(meta)"
                      >
                        Update
                      </button>

                      <!-- Page Button - outline success -->
                      <button
                        class="btn btn-outline-success shadow-sm"
                        @click="goToSchema(meta.id)"
                      >
                        Page
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                class="d-flex justify-content-center align-items-center mt-3 px-2"
              >
                <button
                  class="text-black mx-2"
                  :disabled="currentPage === 1"
                  @click="currentPage = 1"
                >
                  PREV
                </button>
                <button
                  class="text-black mx-2"
                  :disabled="currentPage === 1"
                  @click="currentPage--"
                >
                  &laquo;
                </button>
                <span>Page {{ currentPage }} of {{ totalPages }}</span>
                <button
                  class="text-black mx-2"
                  :disabled="currentPage === totalPages"
                  @click="currentPage++"
                >
                  &raquo;
                </button>
                <button
                  class="text-black mx-2"
                  :disabled="currentPage === totalPages"
                  @click="currentPage = totalPages"
                >
                  NEXT
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Create Metadata Modal -->
    <div
      class="modal fade"
      id="createMetaModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-lg modal-dialog-scrollable"
        style="min-height: 90vh"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Create SEO Metadata</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submitMeta">
              <div class="row g-3">
                <div class="col-md-12">
                  <label class="form-label text-black">Title</label>
                  <input
                    type="text"
                    class="form-control shadow-sm rounded-3 border-primary"
                    v-model="newMeta.title"
                    required
                  />
                </div>
                <div class="col-md-12">
                  <label class="form-label text-black">Target</label>

                  <select
                    class="form-select"
                    v-model="selectedTarget"
                    @change="onTargetChange"
                    required
                  >
                    <option disabled value="">Select a target</option>
                    <option v-for="t in targets" :key="t.id" :value="t">
                      {{ t.type }} - {{ t.target_index }}
                    </option>
                  </select>
                </div>
                <div class="modal-body">
                  <textarea
                    class="form-control"
                    style="
                      font-family: monospace;
                      white-space: pre;
                      height: 200px;
                    "
                    v-model="newMeta.schema"
                  ></textarea>
                </div>
                <!-- <div class="col-md-12">
                  <label class="form-label text-black">Description</label>
                  <div
                    ref="editor"
                    class="ckeditor"
                    style="
                      height: 250px;
                      width: 100%;
                      border: 1px solid #ced4da;
                      padding: 10px;
                      border-radius: 0.375rem;
                    "
                  ></div>
                </div> -->
              </div>

              <div class="mt-4 d-flex justify-content-end gap-2">
                <button class="btn btn-secondary" data-bs-dismiss="modal">
                  Cancel
                </button>
                <button class="btn btn-success">Save Metadata</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="updateMetaModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-lg modal-dialog-scrollable"
        style="min-height: 90vh"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Update Metadata</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="updateMeta">
              <div class="row g-3">
                <div class="col-md-12">
                  <label class="form-label text-black">Title</label>
                  <input
                    type="text"
                    class="form-control shadow-sm rounded-3 border-primary"
                    v-model="newMeta.title"
                    required
                  />
                </div>
              </div>

              <div class="col-md-12">
                <label class="form-label text-black">Target</label>

                <select
                  class="form-select"
                  v-model="selectedTarget"
                  @change="onTargetChange"
                  required
                >
                  <option disabled value="">target</option>
                  <option v-for="t in targets" :key="t.id" :value="t">
                    {{ t.type }} - {{ t.target_index }}
                  </option>
                </select>

                <!-- Show selected value -->
                <div v-if="selectedTarget" class="mt-2 text-muted">
                  Selected: {{ selectedTarget.type }} -
                  {{ selectedTarget.target_index }}
                </div>
              </div>

              <div class="mt-4 d-flex justify-content-end gap-2">
                <button class="btn btn-secondary" data-bs-dismiss="modal">
                  Cancel
                </button>
                <button class="btn btn-success">Update</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Create Meta Target Modal -->
    <div
      class="modal fade"
      id="createTargetModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Create Meta Target</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submitTarget">
              <div class="mb-3">
                <label class="form-label">Type</label>
                <input
                  type="text"
                  class="form-control shadow-sm rounded-3 border-primary"
                  v-model="newTarget.type"
                  required
                />
              </div>
              <div class="mb-3">
                <label class="form-label">Target Index</label>
                <input
                  type="text"
                  class="form-control shadow-sm rounded-3 border-primary"
                  v-model="newTarget.target_index"
                  required
                />
              </div>

              <div class="text-end">
                <button class="btn btn-secondary mx-1" data-bs-dismiss="modal">
                  Cancel
                </button>
                <button class="btn btn-primary mx-1">Create Target</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="metaTagsModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div
            class="modal-header d-flex justify-content-between align-items-start"
          >
            <h5 class="modal-title">Meta Tags</h5>
            <div class="d-flex flex-column align-items-end">
              <button
                type="button"
                class="btn-close mb-2"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
              <button
                type="button"
                class="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#addMetaTagModal"
              >
                Add
              </button>
            </div>
          </div>

          <div class="modal-body">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Value</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="tag in selectedMetaTags" :key="tag.id">
                  <td>{{ tag.name }}</td>
                  <td>{{ tag.value }}</td>
                  <td>
                    <div class="d-flex justify-content-end gap-2">
                      <button
                        type="button"
                        class="btn btn-primary btn-sm"
                        @click="editMetaTag(tag)"
                        data-bs-toggle="modal"
                        data-bs-target="#editMetaTagModal"
                      >
                        ✎
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger btn-sm"
                        @click="deleteMetaTag(tag.id)"
                      >
                        ✖
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="selectedMetaTags.length === 0">
                  <td colspan="3" class="text-center">No meta tags found</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade"
      id="viewTargetModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div
            class="modal-header d-flex justify-content-between align-items-start"
          >
            <h5 class="modal-title">Targets</h5>
            <div class="d-flex flex-column align-items-end">
              <button
                type="button"
                class="btn-close mb-2"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
          </div>

          <div class="modal-body">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th class="text-start">Target</th>
                  <th class="text-start">Target Index</th>
                  <th class="text-end">Actions</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="tag in targets" :key="tag.id">
                  <td>{{ tag.type }}</td>
                  <td>{{ tag.target_index }}</td>
                  <td>
                    <div class="d-flex justify-content-end gap-2">
                      <button
                        type="button"
                        class="btn btn-primary btn-sm"
                        data-bs-dismiss="modal"
                        data-bs-toggle="modal"
                        @click="editMetaTarget(tag)"
                        data-bs-target="#editTargetsModal"
                      >
                        ✎
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger btn-sm"
                        @click="deleteTarget(tag.id)"
                      >
                        ✖
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="targets.length === 0">
                  <td colspan="3" class="text-center">No meta tags found</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="editMetaTagModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <form class="modal-content" @submit.prevent="updateMetaTag">
          <div class="modal-header">
            <h5 class="modal-title">Edit Meta Tag</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Name</label>
              <input
                type="text"
                class="form-control"
                v-model="editMetaTagData.name"
                required
              />
            </div>
            <!-- <div class="mb-3">
              <label class="form-label">Value</label>
              <input
                type="text"
                class="form-control"
                v-model="editMetaTagData.value"
                required
              />
            </div> -->
            <label class="form-label">Value</label>

            <div style="width: 100%">
              <textarea
                class="form-control"
                style="
                  font-family: monospace;
                  white-space: pre-wrap;
                  word-wrap: break-word;
                  overflow: auto;
                  height: auto;
                  min-height: 200px;
                "
                v-model="editMetaTagData.value"
              ></textarea>
            </div>
          </div>
          <div class="">
            <button type="submit" class="btn btn-primary">Update</button>
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>

    <div
      class="modal fade"
      id="editTargetsModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <form class="modal-content" @submit.prevent="updateTargets">
          <div class="modal-header">
            <h5 class="modal-title">Edit Target</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label class="form-label">Type</label>
              <input
                type="text"
                class="form-control"
                v-model="updateMetaTagData.type"
                required
              />
            </div>
            <div class="mb-3">
              <label class="form-label">Target index</label>
              <input
                type="text"
                class="form-control"
                v-model="updateMetaTagData.target_index"
                required
              />
            </div>
          </div>
          <div class="">
            <button type="submit" class="btn btn-primary">Update</button>
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>

    <div
      class="modal fade"
      id="addMetaTagModal"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <form class="modal-content" @submit.prevent="submitMetaTag">
          <div class="modal-header">
            <h5 class="modal-title">Add Meta Tag</h5>

            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="metaType" class="form-label">Name</label>
              <input
                type="text"
                class="form-control"
                id="metaName"
                name="name"
                v-model="newMetaTag.name"
                required
              />
            </div>
            <!-- <div class="mb-3">
              <label for="metaValue" class="form-label">Value</label>
              <input
                type="text"
                class="form-control"
                id="metaValue"
                name="value"
                v-model="newMetaTag.value"
                required
              />
            </div> -->
            <label class="form-label">Value</label>

            <div style="width: 100%">
              <textarea
                class="form-control"
                style="
                  font-family: monospace;
                  white-space: pre-wrap;
                  word-wrap: break-word;
                  overflow: auto;
                  height: auto;
                  min-height: 200px;
                "
                v-model="newMetaTag.value"
              ></textarea>
            </div>
          </div>
          <div class="justify-content-end">
            <button type="submit" class="btn btn-primary">Save</button>
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="schemaModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Schema JSON</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
            ></button>
          </div>
          <div class="modal-body">
            <textarea
              class="form-control"
              style="font-family: monospace; white-space: pre; height: 200px"
              v-model="selectedSchema"
            ></textarea>
          </div>
          <div class="d-flex justify-content-end gap-2">
            <button type="button" class="btn btn-primary" @click="saveSchema">
              Save
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
// import axios from "axios";
import axios from "../services/api";

export default {
  name: "MetaManager",
  data() {
    return {
      selectedCountry: "CG",
      countries: [],
      selectedLang: "en", // default language
      currentPage: 1,
      pageSize: 10,
      metadata: [],
      selectedSchema: "",
      selectedSchemaID: 0,
      selectedMetaTags: [],
      selectedMetaId: "",
      selectedTarget: "",
      selectedUTarget: "",
      selectedMetadataId: "",
      targetID: "",
      metaInfo: "",
      targets: [],
      editMetaTagData: {
        id: null,
        name: "",
        value: "",
      },
      updateMetaTagData: {
        id: 0,
        type: "",
        target_index: "",
      },
      quill: null,
      content: "",
      languages: [],
      newMeta: {
        id: null,
        title: "",
        type_id: 0,
        schema: "",
      },
      newTarget: {
        type: "",
        target_index: "",
      },
      newMetaTag: { name: "", value: "" },
    };
  },
  computed: {
    paginatedMetadata() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.metadata.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.metadata.length / this.pageSize);
    },
  },
  watch: {
    selectedLang(newLang) {
      this.fetchAllMetadata(newLang, this.selectedCountry);
    },
    selectedCountry(newCountry) {
      this.fetchAllMetadata(this.selectedLang, newCountry);
    },
  },
  mounted() {

    this.getLanguages();
    // this.fetchAllMetadata();
    this.fetchAllTargets();
    this.getCountries();

    this.fetchAllMetadata(this.selectedLang, this.selectedCountry);

    this.quill = new Quill(this.$refs.editor, {
      theme: "snow",
      placeholder: "Type here...",
    });
    this.quill.on("text-change", () => {
      this.newMeta.description = this.quill.root.innerHTML;
    });
    this.quill.on("text-change", () => {
      this.content = this.quill.root.innerHTML; // Get the HTML content from the editor
    });
    this.fetchAllMetadata(this.selectedLang, this.selectedCountry);

  },
  methods: {
    async getCountries() {
      try {
        const response = await axios.get(`countries`, {
          headers: {
            "api-key": Cookies.get("authToken"),
          },
        });

        if (response.status === 200 && Array.isArray(response.data.countries)) {
          this.countries = response.data.countries;

          // 👇 ensure selected country exists
          if (
            !this.selectedCountry ||
            !this.countries.some((c) => c.code === this.selectedCountry)
          ) {
            this.selectedCountry = this.countries[0].code;
          }
        } else {
          this.countries = [];
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    async getLanguages() {
      try {
        const response = await axios.get(`languages`, {
          headers: {
            "Content-Type": "multipart/form-data",
            "api-key": `${Cookies.get("authToken")}`,
          },
        });

        console.log(response);

        if (response.status == 200 && Array.isArray(response.data.languages)) {
          this.languages = response.data.languages;
        } else {
          this.languages = [];
        }
      } catch (error) {
        console.error("Error fetching languages:", error);
        if (error.status == 404) {
          this.$notify({
            message:
              error.response?.data?.message ||
              error.response?.data?.error_message,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        } else if (error.status == 401) {
          this.$notify({
            message: error.response.data.error_message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          this.$router.push("/login");
          Cookies.remove("authToken");
        } else {
          this.$notify({
            message:
              error.response.data.error_message || error.response.data.message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
      }
    },
    goToSchema(id) {
      this.$router.push({ name: "SchemaPage", params: { id } });
    },
    async loadMetaTags(metaId) {
      try {
        const res = await axios.get(`get/meta/${metaId}/tags`, {
          headers: {
            Accept: "application/json",
            "api-key": Cookies.get("authToken"),
          },
        });
        this.selectedMetaTags = [];
        if (res.status === 200 || res.status === 201) {
          this.selectedMetaId = metaId;
          if (res.data && res.data["meta"]) {
            this.selectedMetaTags = res.data["meta"];
          }
        }
      } catch (error) {
        // Check error status safely
        const status = error.response?.status;
        if (status !== 200 && status !== 201) {
          this.$notify({
            message: error.message || "An error occurred",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
        console.error("Failed to load meta tags:", error);
        this.selectedMetaTags = [];
      }
    },
    async saveSchema() {
      if (!this.selectedSchema || this.selectedSchema.trim() === "") {
        this.$notify({
          message: "Schema is empty!",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
        return;
      }

      try {
        const parsedSchema = JSON.parse(this.selectedSchema);

        await axios.put(
          `update/json/schema/${this.selectedSchemaID}`,
          {
            schema_json: JSON.stringify(parsedSchema),
          },
          {
            headers: {
              Accept: "application/json",
              "api-key": Cookies.get("authToken"),
            },
          }
        );
        this.$notify({
          message: "Schema saved successfully!",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });
        // alert("Schema saved successfully!");

        // Hide the Bootstrap 5 modal properly
        const schemaModal = bootstrap.Modal.getInstance(
          document.getElementById("schemaModal")
        );
        if (schemaModal) {
          schemaModal.hide();
        }
      } catch (error) {
        this.$notify({
          message: error.message,
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
        // alert("Failed to save schema: " + error.message);
      }
    },
    updateSchema(metaInfo) {
      this.newMeta.title = metaInfo.title;
      this.newMeta.type = metaInfo.type;
      this.newMeta.target_index = metaInfo.target_index;
      this.selectedMetadataId = metaInfo.page_id;

      console.log("SELECTED META DATA",this.selectedMetadataId);
      console.log("SELECTED META DATA",metaInfo);
      const schemaModal = new bootstrap.Modal(
        document.getElementById("updateMetaModal")
      );
      schemaModal.show();
    },

    showSchema(schemaJson, id) {
      try {
        // Handle null or empty string
        if (!schemaJson || schemaJson.trim() === "") {
          this.selectedSchema = "// No schema JSON provided";
        } else {
          // Decode HTML entities if needed
          let decodedJson = schemaJson;
          if (schemaJson.includes("&quot;") || schemaJson.includes("&#")) {
            const txt = document.createElement("textarea");
            txt.innerHTML = schemaJson;
            decodedJson = txt.value;
          }

          console.log("Decoded schemaJson:", decodedJson);

          const parsed = JSON.parse(decodedJson);
          this.selectedSchema = JSON.stringify(parsed, null, 2);
        }

        this.selectedSchemaID = id;

        const schemaModal = new bootstrap.Modal(
          document.getElementById("schemaModal")
        );
        schemaModal.show();
      } catch (error) {
        console.error("Invalid schema JSON", error);
        this.selectedSchema = "// Invalid JSON";
        this.selectedSchemaID = id;
        const schemaModal = new bootstrap.Modal(
          document.getElementById("schemaModal")
        );
        schemaModal.show();
      }
    },
    onLangChange() {
      this.fetchAllMetadata();
    },
    async fetchAllMetadata(lang, country) {
      try {
        const res = await axios.get(`get/all/meta/data?lang=${lang}&country=${country}`, {
          headers: {
            Accept: "application/json",
            "api-key": Cookies.get("authToken"),
          },
        });
        this.metadata = res.data;
      } catch (err) {
        const status = err.response?.status;
        this.metadata = [];
        if (status === 404) {
          this.$notify({
            message:
              err.response?.data?.message || err.response?.data?.error_message,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
      }
    },
    async fetchAllTargets() {
      try {
        const res = await axios.get(
          `/meta/tags`,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              "api-key": Cookies.get("authToken"),
            },
          }
        );
        this.targets = [];

        // Populate with new data
        if (res.data && res.data.meta) {
          this.targets = res.data.meta;
        }
      } catch (error) {
        const status = error.response?.status;

        if (status === 401) {
          this.$notify({
            message: "Session expired, please login",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          Cookies.remove("authToken");
          this.$router.push("/login");
        } else if (status === 404) {
          this.$notify({
            message:
              error.response?.data?.message ||
              error.response?.data?.error_message,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        } else {
          this.$notify({
            message:
              error.response?.data?.message ||
              error.response?.data?.error_message ||
              "An error occurred",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
      }
    },

    async updateMeta() {
      try {
        await axios.put(
          `/page/meta/targets/${this.selectedMetadataId}`,
          {
            title: this.newMeta.title,
            target_id: this.newMeta.type_id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "api-key": Cookies.get("authToken"),
            },
          }
        );
        console.log({
          title: this.newMeta.title,
          target_index: this.newMeta.target_index,
          type: this.newMeta.type,
        });

        this.$notify({
          message: "Metadata created!",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });
        this.fetchAllMetadata(this.selectedLang, this.selectedCountry);
        this.newMeta = {
          seo_target_id: "",
          title: "",
        };
        bootstrap.Modal.getInstance(
          document.getElementById("createMetaModal")
        ).hide();
        window.location.reload();
      } catch (err) {
        console.error("Error creating metadata:", err);
        c;
        // alert("Error creating metadata");
      }
    },
    async submitMeta() {
      try {
        await axios.post(
          `page/meta/tags`,
          {
            title: this.newMeta.title,
            target_id: this.newMeta.type_id,
            schema_json: this.newMeta.schema,
            language: this.selectedLang,
            country: this.selectedCountry,

          },
          {
            headers: {
              "Content-Type": "application/json",
              "api-key": Cookies.get("authToken"),
            },
          }
        );
        console.log({
          title: this.newMeta.title,
          description: this.newMeta.description,
          target_index: this.newMeta.target_index,
          type: this.newMeta.type,
          schema_json: "",
        });

        this.$notify({
          message: "Metadata created!",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });
        // alert("Metadata created!");
        this.fetchAllMetadata(this.selectedLang, this.selectedCountry);
        this.newMeta = {
          seo_target_id: "",
          title: "",
          description: "",
          keywords: "",
          og_image: "",
          og_url: "",
          organization_id: 1,
        };
        bootstrap.Modal.getInstance(
          document.getElementById("createMetaModal")
        ).hide();
        window.location.reload();
      } catch (err) {
        console.error("Error creating metadata:", err);
        c;
        // alert("Error creating metadata");
      }
    },
    async updateTargets() {
      try {
        await axios.put(`/meta/tags/${this.targetID}`, this.updateMetaTagData, {
          headers: {
            "api-key": Cookies.get("authToken"),
          },
        });
        this.$notify({
          message: "Target update successfully!",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });

        this.fetchAllMetadata(this.selectedLang, this.selectedCountry);
        this.fetchAllTargets();

        this.newTarget = { type: "", target_index: "" };
        bootstrap.Modal.getInstance(
          document.getElementById("editTargetsModal")
        ).hide();
        window.location.reload();
      } catch (err) {
        this.$notify({
          message: "Error updating target",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });
        console.error("Error updating target:", err);
      }
    },
    async submitTarget() {
      try {
        await axios.post(`meta/target`, this.newTarget, {
          headers: {
            "api-key": Cookies.get("authToken"),
          },
        });
        this.$notify({
          message: "Target created!",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });

        this.fetchAllTargets();
        this.newTarget = { type: "", target_index: "" };
        bootstrap.Modal.getInstance(
          document.getElementById("createTargetModal")
        ).hide();
        window.location.reload();
      } catch (err) {
        this.$notify({
          message: "Error creating target",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });
        console.error("Error creating target:", err);
      }
    },

    async submitMetaTag() {
      if (!this.selectedMetaId) {
        this.$notify({
          message: "No Meta ID selected",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "warning",
        });
        return;
      }

      try {
        await axios.post(
          `/insert/meta/tags/${this.selectedMetaId}`,
          this.newMetaTag,
          {
            headers: {
              "api-key": Cookies.get("authToken"),
            },
          }
        );

        this.$notify({
          message: "Meta tag inserted",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });
        window.location.reload();

        this.newMetaTag = { name: "", value: "" };

        const addModal = this.getOrCreateModal("addMetaTagModal");
        if (addModal) {
          addModal.hide();
        }

        await this.loadMetaTags(this.selectedMetaId);

        // Wait for hide animation to complete before showing new modal
        setTimeout(() => {
          const tagModal = this.getOrCreateModal("metaTagsModal");
          if (tagModal) {
            console.log("Showing metaTagsModal...");
            tagModal.show();
          } else {
            console.warn("metaTagsModal not found in DOM.");
          }
        }, 400); // 300-500ms is safe for Bootstrap transitions
      } catch (err) {
        this.$notify({
          message:
            err.response?.data?.message ||
            err.message ||
            "Failed to insert meta tag",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
      }
    },
    getOrCreateModal(id) {
      const el = document.getElementById(id);
      let modal = bootstrap.Modal.getInstance(el);
      if (!modal) {
        modal = new bootstrap.Modal(el);
      }
      return modal;
    },

    async deleteMetaTag(tagId) {
      try {
        await axios.delete(`delete/meta/tags/${tagId}`, {
          headers: {
            "api-key": Cookies.get("authToken"),
          },
        });

        this.$notify({
          message: "Meta tag deleted!",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });
        this.newMetaTag = { name: "", value: "" };

        this.loadMetaTags(this.selectedMetaId);
      } catch (err) {
        console.error(
          "Error deleting meta tag:",
          err.response?.data || err.message
        );
        this.$notify({
          message:
            err.response?.data || err.message || "Error deleting meta tag:",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
      }
    },

    async deleteTarget(tagId) {
      try {
        await axios.delete(`/delete/meta/targets/${tagId}`, {
          headers: {
            "api-key": Cookies.get("authToken"),
          },
        });

        this.$notify({
          message: "target deleted!",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });
        this.fetchAllTargets();
      } catch (err) {
        console.error(
          "Error deleting target:",
          err.response?.data || err.message
        );
        this.$notify({
          message: err.response?.data || err.message || "Error deleting target",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
      }
    },
    onTargetChange() {
      if (this.selectedTarget) {
        this.newMeta.target_index = this.selectedTarget.target_index;
        this.newMeta.type = this.selectedTarget.type;
        this.newMeta.type_id = this.selectedTarget.id;
      } else if (this.selectedUTarget) {
        this.newMeta.target_index = this.selectedTarget.target_index;
        this.newMeta.type = this.selectedTarget.type;
        this.newMeta.type_id = this.selectedUTarget.id;
      }
    },
    editMetaTag(tag) {
      this.editMetaTagData = { ...tag };
    },
    editMetaTarget(tag) {
      this.targetID = tag.id;
      this.updateMetaTagData = { ...tag };
    },
    async updateMetaTag() {
      try {
        const updated = {
          name: this.editMetaTagData.name,
          value: this.editMetaTagData.value,
        };

        await axios.put(
          `/update/meta/tags/${this.editMetaTagData.id}`,
          updated,
          {
            headers: {
              "api-key": Cookies.get("authToken"),
            },
          }
        );

        this.$notify({
          message: "Meta tag update was successful",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "success",
        });
        this.loadMetaTags(this.selectedMetaId);

        const modal = bootstrap.Modal.getInstance(
          document.getElementById("editMetaTagModal")
        );
        modal.hide();
        window.location.reload();
      } catch (error) {
        this.$notify({
          message: "Failed to update meta tag",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
        console.error("Failed to update meta tag:", error);
      }
    },
  },
};
</script>

<style scoped>
h3 {
  font-weight: bold;
}

.modal-title {
  font-weight: 600;
}

.modal-content {
  text-align: start;
  width: 100%;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.form-label {
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #212529;
}

input.form-control,
select.form-select {
  transition: box-shadow 0.3s ease-in-out;
}

input.form-control:focus,
select.form-select:focus {
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  border-color: #86b7fe;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

.btn {
  border-radius: 8px;
}

.ck-editor__editable {
  min-height: 100%;
  border-radius: 0.375rem;
}
.modal-footer {
  display: flex !important;
  flex-wrap: nowrap !important;
  gap: 0.5rem;
}
.hover-white:hover {
  color: white;
}
</style>
